const RU_FORMS = {
  test: {
    one: 'тест',
    few: 'теста',
    many: 'тестов',
    other: 'тестов',
  },
  project: {
    one: 'проект',
    few: 'проекта',
    many: 'проектов',
    other: 'проектов',
  },
  phrase: {
    one: 'фраза',
    few: 'фразы',
    many: 'фраз',
    other: 'фраз',
  },
  shop: {
    one: 'магазин',
    few: 'магазина',
    many: 'магазинов',
    other: 'магазинов',
  },
  article: {
    one: 'артикул',
    few: 'артикула',
    many: 'артикулов',
    other: 'артикулов',
  },
  day: {
    one: 'день',
    few: 'дня',
    many: 'дней',
    other: 'дней',
  },
  hour: {
    one: 'час',
    few: 'часа',
    many: 'часов',
    other: 'часов',
  },
  minute: {
    one: 'минута',
    few: 'минуты',
    many: 'минут',
    other: 'минут',
  },
} as const;

type RuKey = keyof typeof RU_FORMS;
type RuForms = typeof RU_FORMS[RuKey];

const ruPlural = new Intl.PluralRules('ru-RU');

export function pluralizeRu(key: RuKey, count: number): string {
  const forms: RuForms = RU_FORMS[key];
  const category = ruPlural.select(Math.abs(count));

  return forms[category as keyof RuForms] ?? forms.many;
}
